// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"219":"e6a00f2e","346":"2a812940","624":"2c3c52de","862":"e5836f0f"}[chunkId] + ".chunk.js";
};